export enum HalfPriceStatus {
	Pending = "pending",
	Approved = "approved",
	Reproved = "reproved",
}
